<template>
  <div>
    <b-row>
      <!--S3-->
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="ConfigName" isMandatory disabled
          :inputLabel="$t('common.routing.config_name')" :placeholderValue="$t('common.routing.config_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="BucketName" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.bucket_name')" :placeholderValue="$t('common.routing.bucket_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="Port" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.port')" :placeholderValue="$t('common.routing.port')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="URI" isMandatory :disabled="readonly" :maxLength="512"
          :inputLabel="$t('common.routing.uri')" :placeholderValue="$t('common.routing.uri')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="Prefix" isMandatory :disabled="readonly" :maxLength="512"
          :inputLabel="$t('common.routing.prefix')" :placeholderValue="$t('common.routing.prefix')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="Region" isMandatory :disabled="readonly" :maxLength="512"
          :inputLabel="$t('common.routing.region')" :placeholderValue="$t('common.routing.region')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="SecretKey" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.secret_key')" :placeholderValue="$t('common.routing.secret_key')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="Scheme" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.scheme')" :placeholderValue="$t('common.routing.scheme')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="useDualStack" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.use_dual_stack')" :placeholderValue="$t('common.routing.use_dual_stack')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="maxConnections" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.max_connections')" :placeholderValue="$t('common.routing.max_connections')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="RequestTimeoutMs" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.request_timeout_ms')" :placeholderValue="$t('common.routing.request_timeout_ms')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="ConnectTimeoutMs" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.connect_timeout_ms')" :placeholderValue="$t('common.routing.connect_timeout_ms')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="enableTcpKeepAlive" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.enable_tcp_keep_alive')" :placeholderValue="$t('common.routing.enable_tcp_keep_alive')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="tcpKeepAliveInvervalMs" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.tcp_keep_alive_inverval_ms')" :placeholderValue="$t('common.routing.tcp_keep_alive_inverval_ms')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="lowSpeedLimit" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.low_speed_limit')" :placeholderValue="$t('common.routing.low_speed_limit')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="VerifySSL" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.verify_ssl')" :placeholderValue="$t('common.routing.verify_ssl')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="FollowRedirects" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.follow_redirects')" :placeholderValue="$t('common.routing.follow_redirects')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="DisableExpectHeader" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.disable_expect_header')" :placeholderValue="$t('common.routing.disable_expect_header')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="EnableClockSkewAdjustement" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.enable_clock_skew_adjustement')" :placeholderValue="$t('common.routing.enable_clock_skew_adjustement')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="enableHostPrefixInfection" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.enable_host_prefix_infection')" :placeholderValue="$t('common.routing.enable_host_prefix_infection')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="enableEndpointdiscovery" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.enable_endpoint_discovery')" :placeholderValue="$t('common.routing.enable_endpoint_discovery')">
        </form-write-group-label-input>
      </b-col>
<!--      <b-col sm="6" class="form-group">-->
<!--        <form-write-group-label-input v-model="caPath" isMandatory :disabled="readonly"-->
<!--          :inputLabel="$t('common.routing.ca_path')" :placeholderValue="$t('common.routing.ca_path')">-->
<!--        </form-write-group-label-input>-->
<!--      </b-col>-->
<!--      <b-col sm="6" class="form-group">-->
<!--        <form-write-group-label-input v-model="caFile" isMandatory :disabled="readonly"-->
<!--          :inputLabel="$t('common.routing.ca_file')" :placeholderValue="$t('common.routing.ca_file')">-->
<!--        </form-write-group-label-input>-->
<!--      </b-col>-->
      <b-col sm="6" class="form-group" >
        <form-write-group-label-input v-model="AccessKey" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.access_key')" :placeholderValue="$t('common.routing.access_key')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="inputValue.Role != 1">
        <form-write-group-label-input v-model="MinBufferSize" isMandatory :disabled="inputValue.Role == 1 || readonly"
          :inputLabel="$t('common.routing.min_buffer_size')" :tooltipLabel="inputValue.Role == 1 ? undefined:$t('common.routing.min_buffer_output_size')" :placeholderValue="$t('common.routing.min_buffer_size')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" >
        <form-write-group-label-input v-model="MaxBufferSize" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.max_buffer_size')" :tooltipLabel="inputValue.Role == 1 ? $t('common.routing.max_buffer_size_input'):$t('common.routing.max_buffer_size_output')" :placeholderValue="$t('common.routing.max_buffer_size')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="inputValue.Role == 1">
        <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s" isMandatory
                                :class="{'filter-item-input': true, 'filter-item-input-complete': BeginDate}"
                                :inputLabel="$t('common.routing.begin_date')"
                                customInputParentClass="filter-item-content"
                                customInputClass="w-100"
                                :maxLength="19"
                                :tooltipLabel="inputValue.Role == 1 ? $t('common.routing.date_begin_input'):undefined"
                                :placeholderValue="$t('common.datetime_picker_empty_date')"
                                inputIcon="fa-solid fa-calendar"
                                v-model="BeginDate" :disabled="inputValue.Role == 0 || readonly">
        </datetime-picker-custom>
      </b-col>
      <b-col sm="6" class="form-group" v-if="false" >
        <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s" isMandatory
                                :class="{'filter-item-input': true, 'filter-item-input-complete': EndDate}"
                                :inputLabel="$t('common.routing.end_date')"
                                customInputParentClass="filter-item-content"
                                customInputClass="w-100"
                                :maxLength="19"
                                :placeholderValue="$t('common.datetime_picker_empty_date')"
                                inputIcon="fa-solid fa-calendar"
                                v-model="EndDate" disabled>
        </datetime-picker-custom>
      </b-col>
<!--      <b-col sm="6" class="form-group">-->
<!--        <label for="ssl-active">-->
<!--          {{ $t('common.routing.ssl_active') }}<span class="color-red"> * </span>-->
<!--        </label>-->
<!--        <select class="form-control" v-model="sslActive" :disabled="readonly" id="ssl-active">-->
<!--          <option value="1"> {{ $t('common.routing.yes') }} </option>-->
<!--          <option value="0" selected> {{ $t('common.routing.no') }} </option>-->
<!--        </select>-->
<!--      </b-col>-->
<!--      <b-col v-if="sslActive != '0'" sm="6" class="form-group">-->
<!--        <label for="keystore">-->
<!--          {{ $t('common.routing.keystore') }}<span class="color-red"> * </span>-->
<!--        </label>-->
<!--        <select class="form-control" v-model="keystore" :disabled="readonly" id="keystore">-->
<!--          <option v-for="keystore in keystoreList" :key="keystore.id" :value="keystore.id"> {{ keystore.ConfigName }} </option>-->
<!--        </select>-->
<!--      </b-col>-->
<!--      <b-col sm="6" v-if="sslActive != '0'" class="form-group">-->
<!--        <label for="ca">-->
<!--          {{ $t('common.routing.certificat') }}-->
<!--&lt;!&ndash;          <span class="color-red"> * </span>&ndash;&gt;-->
<!--        </label>-->
<!--        <select class="form-control" v-model="ca" :disabled="readonly" id="ca">-->
<!--          <option v-for="ca in caList" :key="ca.id" :value="ca.id"> {{ ca.ConfigName }} </option>-->
<!--        </select>-->
<!--      </b-col>-->
    </b-row>
<!--    <form-accordion :title="$t('common.token_credentials')" :isTitleUpperCase="false" v-if="login && password">-->
<!--      <b-row>-->
<!--        <b-col cols="6" class="fake-hr-right px-0">-->
<!--          <b-col class="form-group">-->
<!--            <form-write-group-label-input v-model="loginStorage" :disabled="true" :maxLength="512" inputType="select"-->
<!--              :inputLabel="$t('common.routing.loginStorage')">-->
<!--              <select class="form-control" v-model="loginStorage" :disabled="true">-->
<!--                <option value="">{{ $t('common.routing.volume_select') }}</option>-->
<!--                <option value="PEM">{{ 'PEM' }}</option>-->
<!--                <option value="FILE">{{ 'Volume' }}</option>-->
<!--                <option value="Vault">{{ 'Vault' }}</option>-->
<!--              </select>-->
<!--            </form-write-group-label-input>-->
<!--          </b-col>-->
<!--          <b-col class="form-group">-->
<!--            <b-row>-->
<!--              <b-col cols="8">-->
<!--                <form-write-group-label-input v-model="loginFile" :disabled="true" :maxLength="512"-->
<!--                  :inputLabel="$t('common.routing.loginFile')" :placeholderValue="$t('common.routing.loginFile')">-->
<!--                </form-write-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col cols="4">-->
<!--                <label for="login-file-type">{{ $t('common.variable') }}</label>-->
<!--                <b-form-radio-group v-model="loginFileType" :disabled="true" id="login-file-type">-->
<!--                  <b-form-radio ConfigName="variableP12PwdInsideFile-radio" value="ENV">{{ $t('common.env') }}</b-form-radio>-->
<!--                  <b-form-radio ConfigName="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>-->
<!--                </b-form-radio-group>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--          </b-col>-->
<!--          <b-col class="form-group">-->
<!--            <b-row>-->
<!--              <b-col cols="8">-->
<!--                <form-write-group-label-input v-model="loginYAML" :disabled="true" :maxLength="512"-->
<!--                  :inputLabel="$t('common.routing.loginYAML')" :placeholderValue="$t('common.routing.loginYAML')">-->
<!--                </form-write-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col cols="4">-->
<!--                <label for="login-yaml-type">{{ $t('common.variable') }}</label>-->
<!--                <b-form-radio-group v-model="loginYAMLType" :disabled="true" id="login-yaml-type">-->
<!--                  <b-form-radio ConfigName="variableP12PwdInsideFile-radio" value="ENV">{{ $t('common.env') }}</b-form-radio>-->
<!--                  <b-form-radio ConfigName="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>-->
<!--                </b-form-radio-group>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--          </b-col>-->

<!--        </b-col>-->
<!--        <b-col cols="6" class="px-0">-->
<!--          <b-col class="form-group">-->
<!--            <form-write-group-label-input v-model="passwordStorage" :disabled="true" :maxLength="512" inputType="select"-->
<!--              :inputLabel="$t('common.routing.passwordStorage')">-->
<!--              <select class="form-control" v-model="loginStorage" :disabled="true">-->
<!--                <option value="">{{ $t('common.routing.volume_select') }}...</option>-->
<!--                <option value="PEM">{{ 'PEM' }}</option>-->
<!--                <option value="FILE">{{ 'Volume' }}</option>-->
<!--                <option value="Vault">{{ 'Vault' }}</option>-->
<!--              </select>-->
<!--            </form-write-group-label-input>-->
<!--          </b-col>-->
<!--          <b-col class="form-group">-->
<!--            <b-row>-->
<!--              <b-col cols="8">-->
<!--                <form-write-group-label-input v-model="passwordFile" :disabled="true" :maxLength="512"-->
<!--                  :inputLabel="$t('common.routing.passwordFile')" :placeholderValue="$t('common.routing.passwordFile')">-->
<!--                </form-write-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col cols="4">-->
<!--                <label for="pwd-file-type">{{ $t('common.variable') }}</label>-->
<!--                <b-form-radio-group v-model="passwordFileType" :disabled="true" id="pwd-file-type">-->
<!--                  <b-form-radio ConfigName="variableP12PwdInsideFile-radio" value="ENV">{{ $t('common.env') }}</b-form-radio>-->
<!--                  <b-form-radio ConfigName="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>-->
<!--                </b-form-radio-group>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--          </b-col>-->
<!--          <b-col class="form-group">-->
<!--            <b-row>-->
<!--              <b-col cols="8">-->
<!--                <form-write-group-label-input v-model="passwordYAML" :disabled="true" :maxLength="512"-->
<!--                  :inputLabel="$t('common.routing.passwordYAML')" :placeholderValue="$t('common.routing.passwordYAML')">-->
<!--                </form-write-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col cols="4">-->
<!--                <label for="pwd-yaml-type">{{ $t('common.variable') }}</label>-->
<!--                <b-form-radio-group v-model="passwordYAMLType" :disabled="true" id="pwd-yaml-type">-->
<!--                  <b-form-radio ConfigName="variableP12PwdInsideFile-radio" value="ENV">{{ $t('common.env') }}</b-form-radio>-->
<!--                  <b-form-radio ConfigName="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>-->
<!--                </b-form-radio-group>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--          </b-col>-->
<!--        </b-col>-->
<!--      </b-row>-->
<!--    </form-accordion>-->
<!--    <level-control-form v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="controlConfig" :placementLevel="placementWebService"></level-control-form>-->

    <form-accordion :title="$t('common.proxy')" :isTitleUpperCase="false">
      <b-row class="form-group">
        <b-col sm="6" class="form-group">
          <label for="proxy-active">
            {{ $t('common.routing.proxy_active') }}<span class="color-red"> * </span>
          </label>
          <select class="form-control" v-model="proxyActive" :disabled="readonly" id="proxy-active">
            <option value="1"> {{ $t('common.routing.yes') }} </option>
            <option value="0" selected> {{ $t('common.routing.no') }} </option>
          </select>
        </b-col>
        <b-col sm="6" class="form-group"></b-col>
        <b-col sm="6" class="form-group" v-if="proxyActive == '1'">
          <form-write-group-label-input v-model="proxyScheme" :disabled="readonly" :maxLength="512"
            :inputLabel="$t('common.routing.proxy_scheme')" :placeholderValue="$t('common.routing.proxy_scheme')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="proxyActive == '1'">
          <form-write-group-label-input v-model="proxyHost" :disabled="readonly" :maxLength="512"
            :inputLabel="$t('common.routing.proxy_host')" :placeholderValue="$t('common.routing.proxy_host')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="proxyActive == '1'">
          <form-write-group-label-input v-model="proxyPort" :disabled="readonly" :maxLength="512"
            :inputLabel="$t('common.routing.proxy_port')" :placeholderValue="$t('common.routing.proxy_port')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="proxyActive == '1'">
          <form-write-group-label-input v-model="proxyLogin" :disabled="readonly" :maxLength="512"
            :inputLabel="$t('common.routing.proxy_login')" :placeholderValue="$t('common.routing.proxy_login')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="proxyActive == '1'">
          <form-write-group-label-input v-model="proxyPwd" :disabled="readonly" :maxLength="512"
            :inputLabel="$t('common.routing.proxy_pwd')" :placeholderValue="$t('common.routing.proxy_pwd')">
          </form-write-group-label-input>
        </b-col>
      </b-row>
    </form-accordion>
    <!--<certificate-form-global v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="certificateConfig" :placementCertificate="placementWebService"></certificate-form-global>
    <private-keys-form-global v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="privateKeysConfig" :placementPrivateKey="placementWebService"></private-keys-form-global>-->
  </div>
</template>
<script>

import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import LevelControlForm from '@/pages/routing/global/LevelControlForm.vue'
import {errorMessageAlert} from '@/helpers/alert'
import dateTimePicker from "@/components/common/dateTimePicker.vue";

export default {
  ConfigName: 'WebServiceConfigurationForm',
  components: {
    'datetime-picker-custom': dateTimePicker,
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'level-control-form' : LevelControlForm
  },
  props: {
    mode: {
      type: String,
      default: "create"
    },
    prefilledURI: {
      type: String,
      default: ''
    },
    placementWebService: {
      type: Number,
      default: -1
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }

  },
  computed:{
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    SecretKey: {
      get () {
        return this.inputValue.SecretKey
      },
      set (val) {
        this.inputValue = {
          SecretKey: val,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    AccessKey: {
      get () {
        return this.inputValue.AccessKey
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: val,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    ConfigName: {
      get () {
        return this.inputValue.ConfigName
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: val,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    Prefix: {
      get () {
        return this.inputValue.Prefix
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: val,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    Region: {
      get () {
        return this.inputValue.Region
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: val,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    BucketName: {
      get () {
        return this.inputValue.BucketName
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: val,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
        }
      }
    },
    Port: {
      get () {
        return this.inputValue.Port
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: val,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    URI: {
      get () {
        return this.inputValue.URI
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: val,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    MinBufferSize: {
      get () {
        return this.inputValue.MinBufferSize
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: val,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    MaxBufferSize: {
      get () {
        return this.inputValue.MaxBufferSize
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: val,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    BeginDate: {
      get () {
        return this.inputValue.BeginDate
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: val,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    EndDate: {
      get () {
        return this.inputValue.EndDate
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: val,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    proxyActive: {
      get () {
        return this.inputValue.proxyActive
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: val,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    proxyScheme: {
      get () {
        return this.inputValue.proxyScheme
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: val,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    proxyPort: {
      get () {
        return this.inputValue.proxyPort
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: val,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    proxyLogin: {
      get () {
        return this.inputValue.proxyLogin
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: val,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    proxyPwd: {
      get () {
        return this.inputValue.proxyPwd
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: val,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    proxyHost: {
      get () {
        return this.inputValue.proxyHost
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: val,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    ForceReOpen: {
      get () {
        return this.inputValue.ForceReOpen
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: val,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    Scheme: {
      get () {
        return this.inputValue.Scheme
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: val,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    useDualStack: {
      get () {
        return this.inputValue.useDualStack
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: val,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    maxConnections: {
      get () {
        return this.inputValue.maxConnections
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: val,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    RequestTimeoutMs: {
      get () {
        return this.inputValue.RequestTimeoutMs
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: val,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    ConnectTimeoutMs: {
      get () {
        return this.inputValue.ConnectTimeoutMs
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: val,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    enableTcpKeepAlive: {
      get () {
        return this.inputValue.enableTcpKeepAlive
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: val,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    tcpKeepAliveInvervalMs: {
      get () {
        return this.inputValue.tcpKeepAliveInvervalMs
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: val,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    lowSpeedLimit: {
      get () {
        return this.inputValue.lowSpeedLimit
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: val,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    VerifySSL: {
      get () {
        return this.inputValue.VerifySSL
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: val,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    FollowRedirects: {
      get () {
        return this.inputValue.FollowRedirects
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: val,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    DisableExpectHeader: {
      get () {
        return this.inputValue.DisableExpectHeader
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: val,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    EnableClockSkewAdjustement: {
      get () {
        return this.inputValue.EnableClockSkewAdjustement
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: val,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    enableHostPrefixInfection: {
      get () {
        return this.inputValue.enableHostPrefixInfection
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: val,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
        }
      }
    },
    enableEndpointdiscovery: {
      get () {
        return this.inputValue.enableEndpointdiscovery
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: val,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile
        }
      }
    },
    caPath: {
      get () {
        return this.inputValue.caPath
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: val,
          caFile: this.inputValue.caFile
        }
      }
    },
    caFile: {
      get () {
        return this.inputValue.caFile
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: val,
        }
      }
    },
  },
  data () {
    return {
      keystoreList: [],
      caList: []
    }
  },
  created () {
    if (this.mode === 'create') {
      if (this.prefilledURI !== undefined || this.prefilledURI === '') {
        this.inputValue.URI = this.prefilledURI
      }
      this.inputValue.sslActive = '0'
    }
  },
  methods: {
  }
}

</script>
